import { useCallback } from "react";
import {
  UIMatch,
  useLocation,
  useMatches,
  useNavigate,
} from "react-router-dom";
import { LayoutContainer, Navbar, useAuth } from "@jana-technology/platform-ui";

import { isJanaAdmin } from "auth/roles";
import { MainHeader } from "components/headings";
import {
  LOGOUT_ROUTE,
  OVERVIEW_ROUTE,
  OVERVIEW_ROUTE_CHARTS_OPERATIONAL,
  RISK_ROUTE,
  ROUTE_HEADINGS,
  EXPORT_ROUTE,
  CONFIG_ROUTE,
  RISK_ROUTE_CHARTS_OVERALL,
} from "constants/routing";

import type { NavbarHandle, NavbarContainerProps } from "./types";

export const NavbarContainer = ({
  children,
  headerTopText,
  headerActions,
}: NavbarContainerProps) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const matches = useMatches() as Array<UIMatch<unknown, NavbarHandle>>;
  const headerMatch = [...matches]
    .reverse()
    .find((match) => match.handle?.header);
  const headerTitle = headerMatch?.handle.header || ROUTE_HEADINGS["/"];

  const { user } = useAuth();

  const onLogoutClick = useCallback(() => {
    navigate(LOGOUT_ROUTE);
  }, [navigate]);

  const links = [
    ...(isJanaAdmin(user)
      ? [
          {
            active: pathname.includes(CONFIG_ROUTE),
            link: CONFIG_ROUTE,
            label: "Configuration",
          },
        ]
      : []),
    {
      active: pathname.includes(OVERVIEW_ROUTE),
      link: OVERVIEW_ROUTE_CHARTS_OPERATIONAL,
      label: "System Overview",
    },
    {
      active: pathname.includes(RISK_ROUTE),
      link: RISK_ROUTE_CHARTS_OVERALL,
      label: "Risk Management",
    },
    {
      active: pathname.includes(EXPORT_ROUTE),
      link: EXPORT_ROUTE,
      label: "Export",
    },
  ];

  return (
    <div>
      <Navbar
        userMenuOptions={{
          onLogoutClick,
          appVersion: import.meta.env.LH_APP_VERSION as string,
          user: {
            name: user?.name ?? "User",
            role: user?.role as string,
            avatarSrc: user?.picture,
          },
        }}
        links={links}
      />
      <LayoutContainer>
        <MainHeader title={headerTitle} topText={headerTopText}>
          {headerActions}
        </MainHeader>
        {children}
      </LayoutContainer>
    </div>
  );
};

export default NavbarContainer;
